import { useState } from 'react'

import { Column } from '../../../../components/layouts/columns'
import { Button } from '../../../../components/ui/button'
import { Modal } from '../../../../components/ui/modal'
import { Input } from '../../../../components/ui/input'
import { useGlobalContext } from '../../../../context/ContextGlobal'
import { DateTimeNow, TimestampNow } from '../../../../utils/dates'
import { Icon } from '../../../../components/icons'

export const ModalAddCampaign = ({ loading, active = true, setActive, infoContext, actions }) => {
  const { user } = useGlobalContext()

  const [form, setform] = useState({})

  const response = {
    title: form?.title,
    msg: form?.msg,
    idClient: user?.client?.id,
    createdBy: user?.user?.nome,
    dt_created: DateTimeNow(),
    ts_created: TimestampNow(),
    estimate_send: infoContext?.n_staff_total || 10000,
  }

  if (active) {
    return (
      <div>
        <Modal.Root active={active}>
          <Modal.Contents witdh={700}>
            <Modal.Header title={'Criar Campanha de notificações'}>
              <Modal.HeaderClose setActive={setActive}></Modal.HeaderClose>
            </Modal.Header>

            <Modal.Body>
              {loading ? (
                <>
                  <Column.Root className="is-mobile">
                    <Column.Content></Column.Content>
                    <Column.Content className="is-1">
                      <Icon>loading</Icon>
                    </Column.Content>
                    <Column.Content></Column.Content>
                  </Column.Root>
                </>
              ) : (
                <>
                  <Column.Root>
                    <Column.Content>
                      <Input.Root>
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Nome da Campanha
                        </Input.Label>
                        <Input.Contents>
                          <Input.Prompt
                            className="is-rounded"
                            color="is-grey"
                            value={form}
                            setValue={setform}
                            field={'title'}
                          />
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>

                  <Column.Root>
                    <Column.Content>
                      <Input.Root>
                        <Input.Label className="ml-3 has-text-grey" style={{ marginBottom: 0 }}>
                          Corpo da Mensagem
                        </Input.Label>
                        <Input.Contents>
                          <Input.Textarea
                            className="is-rounded"
                            color="is-grey"
                            value={form}
                            setValue={setform}
                            field={'msg'}
                          />
                        </Input.Contents>
                      </Input.Root>
                    </Column.Content>
                  </Column.Root>
                  <Column.Root>
                    <Column.Content>
                      <div className="notification is-warning is-light is-size-7">
                        <strong>Estimativa de envio:</strong> {infoContext?.n_staff_total || 0} Staffers.
                        <br />A entrega não é garantida. Em média, cerca de <strong>80% das notificações</strong> chegam
                        ao destino.
                        <br />
                        <br />
                        <strong>Possíveis motivos de falha:</strong>
                        <ul>
                          <li>Notificações desativadas no dispositivo;</li>
                          <li>Cadastro incompleto do colaborador;</li>
                          <li>Falhas pontuais no serviço de envio.</li>
                        </ul>
                      </div>
                    </Column.Content>
                  </Column.Root>
                </>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button.Bt
                className="has-background-dark has-text-white"
                action={() => {
                  actions.add(response)
                }}
              >
                Criar Mensagem
              </Button.Bt>

              <Button.Bt
                action={() => {
                  setform({})
                  setActive(false)
                }}
              >
                Cancelar
              </Button.Bt>
            </Modal.Footer>
          </Modal.Contents>
        </Modal.Root>
      </div>
    )
  } else {
    return <></>
  }
}
